module.exports = __webpack_public_path__ + "static/media/prescribe.92d8ec05.png";